var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('a-config-provider',{attrs:{"locale":_vm.zh_CN}},[_c('router-view')],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading",on:{"click":_vm.hideLoading}},[_c('a-spin',{attrs:{"tip":"Loading..."}})],1),_c('a-back-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }